import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTSRV_Please_wait_5_10_more_minutes__ELL,
  TXTWCL_Your_transaction_cannot_be_com_ELL
} from './PayconiqOpenAppFailed.messages.json';

const PayconiqOpenAppFailed: React.FC = () => (
  <>
    <Translation {...TXTWCL_Your_transaction_cannot_be_com_ELL} />
    <Translation {...TXTSRV_Please_wait_5_10_more_minutes__ELL} />
  </>
);

export default PayconiqOpenAppFailed;
